import { formatPrice } from './helpers';

// Shortest realistic international number (country code + subscriber number).
// Anything below this is a typo or a placeholder, not a number worth opening
// WhatsApp for.
const MIN_DIGITS = 8;

// wa.me only accepts digits: no plus, no spaces, no dashes, and the number must
// already carry its country code (the admin form says so). Anything that cannot
// become a usable number normalises to '' so callers can treat it as "not
// configured".
export const normalizeWhatsAppNumber = raw => {
  if (!raw) return '';

  let digits = String(raw).replace(/\D/g, '');

  // '00' is the international dialling prefix; wa.me wants the bare country code.
  if (digits.startsWith('00')) {
    digits = digits.slice(2);
  }

  return digits.length >= MIN_DIGITS ? digits : '';
};

// Builds the "order this product" deep link. Returns null when the shop has no
// usable number configured, which is the caller's cue to keep the flow off.
export const buildWhatsAppOrderUrl = ({
  number,
  product,
  colorName,
  productUrl,
}) => {
  const to = normalizeWhatsAppNumber(number);
  if (!to || !product) return null;

  const price = product.discounted_price || product.price;

  const lines = ["Hi! I'd like to order this watch:", '', `*${product.name}*`];

  if (colorName) {
    lines.push(`Color: ${colorName}`);
  }

  lines.push(`Price: ${formatPrice(price)}`);

  if (productUrl) {
    lines.push('', productUrl);
  }

  return `https://wa.me/${to}?text=${encodeURIComponent(lines.join('\n'))}`;
};
